import React from 'react';
import { Helmet } from 'react-helmet-async';

const LocalBusinessSchema = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": "https://nutricentreriviera.ch/#localbusiness",
    "name": "Harmonie Féminine par Nutri Centre Riviera",
    "alternateName": "Nutri Centre Riviera",
    "description": "Centre pluridisciplinaire de nutrition et santé féminine sur la Riviera vaudoise, spécialisé en nutrition hormonale, SOPK, perte de poids et hypnopraxie. À Vevey et Clarens — proche de Montreux et Lausanne.",
    "url": "https://nutricentreriviera.ch",
    "hasMap": "https://maps.app.goo.gl/daz8s3eydncNWeqPA",
    "logo": "https://nutricentreriviera.ch/images/logo.webp",
    "image": "https://nutricentreriviera.ch/images/logo.webp",
    "telephone": "+41 76 779 93 02",
    "email": "nutririviera@gmail.com",
    "priceRange": "CHF 100-150",
    "currenciesAccepted": "CHF",
    "paymentAccepted": "Cash, Credit Card, Invoice, Insurance",
    "address": [
      {
        "@type": "PostalAddress",
        "streetAddress": "Av. du Général-Guisan 26",
        "addressLocality": "Vevey",
        "addressRegion": "VD",
        "postalCode": "1800",
        "addressCountry": "CH"
      },
      {
        "@type": "PostalAddress",
        "streetAddress": "Rue du Grammont 2",
        "addressLocality": "Clarens",
        "addressRegion": "VD",
        "postalCode": "1815",
        "addressCountry": "CH"
      }
    ],
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "46.4608",
      "longitude": "6.8430"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "13:00"
      }
    ],
    "areaServed": [
      {
        "@type": "City",
        "name": "Vevey"
      },
      {
        "@type": "City",
        "name": "Montreux"
      },
      {
        "@type": "City",
        "name": "Clarens"
      },
      {
        "@type": "City",
        "name": "La Tour-de-Peilz"
      },
      {
        "@type": "City",
        "name": "Lausanne"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Riviera vaudoise"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Canton de Vaud"
      }
    ],
    "medicalSpecialty": [
      "Nutrition",
      "Diététique",
      "Cardiologie nutritionnelle",
      "Hypnopraxie"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Nos prestations",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Consultation Nutrition Hormonale",
            "description": "Prise en charge nutritionnelle pour déséquilibres hormonaux, SOPK, préménopause"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Consultation Perte de Poids Hormonale",
            "description": "Accompagnement nutritionnel pour perte de poids liée aux hormones"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Suivi SOPK",
            "description": "Programme nutritionnel spécialisé pour le syndrome des ovaires polykystiques"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Hypnopraxie",
            "description": "Accompagnement thérapeutique pour équilibre émotionnel et bien-être mental"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Bilan Métabolique",
            "description": "Analyses complètes, composition corporelle, impédancemétrie"
          }
        }
      ]
    },
    "sameAs": [
      "https://www.onedoc.ch/fr/cabinet-de-groupe/vevey/ebdj4/nutri-centre-riviera",
      "https://maps.app.goo.gl/daz8s3eydncNWeqPA"
    ],
    "employee": {
      "@type": "Person",
      "@id": "https://nutricentreriviera.ch/equipe#zara-nawid",
      "name": "Zara Nawid",
      "jobTitle": "Nutritionniste diplômée — Thérapeute en nutrition MCO",
      "worksFor": { "@id": "https://nutricentreriviera.ch/#localbusiness" },
      "image": "https://nutricentreriviera.ch/images/zara-nawid.webp",
      "knowsAbout": [
        "SOPK",
        "Hormones féminines",
        "Perte de poids durable",
        "Préménopause et ménopause",
        "Nutrition métabolique"
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
